export function EstimatedTime (number) {
    if (typeof number !== "number" || number <= 0) {
        return " "
    }
    let m = Math.floor(number / 60);
    let s = Math.floor(number % 60);

    // return (m < 10 ? "0" + m : m) + " 分 " + (s < 10 ? "0" + s : s) + " 秒 "
    return m + " m " + (s < 10 ? "0" + s : s) + " s "
}